"use client"

import { HomePageLayout } from "@/components/website/homepage-layout"

export default function UserPolicyPage() {
  return (
    <HomePageLayout>
      <div className="container mx-auto px-4 py-6 space-y-4">
        <h1 className="text-2xl font-bold">User Policy</h1>
        <p className="text-sm text-muted-foreground">
          By accessing and using Oxygen Tamil News, you agree to follow the guidelines and policies below. These rules are designed to keep the platform
          safe, respectful and reliable for every reader.
        </p>
        <ul className="list-disc pl-6 space-y-2 text-sm text-muted-foreground">
          <li>
            You may share our links on social media, but copying full articles or republishing our content without written permission is not allowed.
          </li>
          <li>
            Comments and submitted content should avoid abusive language, personal attacks, hate speech, spam or illegal activity.
          </li>
          <li>
            We may moderate, edit or remove any user-generated content that violates our guidelines or applicable law.
          </li>
          <li>
            Information on the site is provided for general information only; we are not responsible for decisions taken solely on the basis of our content.
          </li>
          <li>
            We may update this User Policy from time to time; continuing to use the site after changes means you accept the updated terms.
          </li>
        </ul>
      </div>
    </HomePageLayout>
  )
}


